<template>
  <div class="ml-3">
    <el-row class="mb-3" v-if="amReady">
      <div class="m-0 p-0 mb-5 border-bottom" v-if="formHeader">
        <h5>{{ this.getFormTitle }}</h5>
      </div>
      <div class="mb-2" v-else></div>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :control="control"
            :field_span="19"
            :label_span="24"
            :options="vendorsList"
            :translateLabel="false"
            :translateLabels="false"
            :defaultValue="targetVendorId"
            :disabled="targetVendorId"
            @amUpdated="vendorChanged"
            field_mark="required"
            label="Vendor"
            name="vendor_id"
            rules="required"></dg-select-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :control="control"
            :field_span="19"
            :label_span="24"
            :options="destinationsDropDownList"
            :translateLabel="false"
            :translateLabels="false"
            @amUpdated="destinationChanged"
            field_mark="required"
            htmlautocomplete="new-password"
            label="Destination"
            labelProperty="label"
            name="destination_id"
            placeholder="Canada / ATI"
            rules="required"
            valueProperty="value"
        ></dg-select-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :field_span="19"
            :label_span="24"
            field_mark="required"
            :translateLabel="false"
            label="Dialcode"
            name="dialcode"
            placeholder="234"
            rules="required"></dg-text-field>
      </el-col>

      <el-col class="mt-2" :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-button class="mr-2 mt-4" :translate="false" text="Search" type="primary" icon="el-icon-refresh" fieldSize="mini" :click="makeSearch"></dg-button>
        <dg-button class="mr-2 mt-4" :translate="false" text="Reset Search" type="primary" icon="el-icon-refresh" fieldSize="mini" :click="resetSearchFields"></dg-button>
      </el-col>

    </el-row>

    <el-row class="mb-3" v-if="vendorIsSelected">
      <div class="p-3">
        <div class="row">
          <!--<div class="col-12 col-md-6">
            <span class="ag-grid-quick-search-label">Search</span>
            <span><el-input class="d-inline-block w-50" size='mini' v-model="userSearch"></el-input></span>
          </div>-->
          <div class="col-12 col-md-12">
            <pagination
                :currentPage="currentPage"
                :margin-pages="2"
                :navigateHandler="navigateToPage"
                :page-count="getPagesCount()"
                :page-range="4"
                paginateClass=""></pagination>
          </div>
        </div>
      </div>

      <el-tag type="success">Rates Counter: {{ recordsCounter }}</el-tag>

      <el-table
          :data="rates"
          style="width: 100%">
        <el-table-column
            label="Destination"
            prop="destination">
        </el-table-column>
        <el-table-column
            label="dialcode"
            prop="dialcode">
        </el-table-column>
        <el-table-column
            label="Rate"
            prop="rate">
        </el-table-column>
        <el-table-column
            label="Created"
            prop="created_at">
        </el-table-column>
        <el-table-column
            label="Actions"
            prop="id">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="removeAction(scope.row.id, scope)">Delete</el-button>
          </template>
        </el-table-column>
      </el-table>


      <!--<el-col :span="24" class="mt-2">
        <el-col :class="$langConfig.cssClass" :span="12" class="mt-4">
          <dg-label-field class="error-field-validate-message" label="fields_do_not_match_the_required_criteria"
                          v-show="!this.validData"></dg-label-field>
        </el-col>
      </el-col>-->
    </el-row>
  </div>
</template>

<script>
import Vue from 'vue'
import {mapState, mapActions} from 'vuex'
import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import module from './../index.js'
import {notify} from '@/system-services/notify.js'

export default {
  watch: {
    userSearch: function (val) {
      this.agGrid.gridApi.setQuickFilter(val);
    }
  },
  components: {
    pagination: () => import('@/components/pagination/View.vue'),
  },
  mixins: [fieldController],
  props: {
    targetVendorId: {
      required: false,
      default: null
    },
    formHeader: {
      required: false,
      default: false
    },
    formTitle: {
      required: false
    },
    editMode: {
      required: true,
      type: Boolean
    },
    onEditCallback: {
      required: false
    },
    onCreateCallback: {
      required: false
    },
  },
  data() {
    return {
      destinationsDropDownList: [],
      dataModel: {
        vendor_id: null,
        destination_id: '',
        dialcode: '',
      },
      recordsCounter: 0,
      vendorIsSelected: false,
      pageChunkSize: 12,
      currentPage: 1,
      control: this,
      amReady: true,
      userSearch: null,
      requestOn: false,
      editable: !this.editMode,
      vendorsList: [],
      rates: [],
      module: {
        ...module
      }
    }
  },
  computed: {
    ...mapState('voip-dialplan-state', ['openedEntity']),
    ...mapState('ajaxManager', ['loadingRequests']),
    getFormTitle: function () {
      if (this.formTitle) {
        return this.formTitle
      } else {
        return ((!this.editMode) ? this.$ml.get('create') : this.$ml.get('edit')) + ' ' + this.module.info.caption
      }
    },
    actionButtonLabel: function () {
      if (!this.editMode) {
        return 'create';
      } else {
        return 'save'
      }
    },
    actionButtonIcon: function () {
      if (!this.editMode) {
        return 'el-icon-plus';
      } else {
        return 'el-icon-check'
      }
    },
    actionButtonType: function () {
      if (!this.validData) {
        return 'danger btn-small';
      } else {
        if (!this.editMode) {
          return 'primary app-bg-primary';
        } else {
          return 'primary'
        }
      }
    }
  },
  beforeMount() {
    if (this.targetVendorId) {
        this.vendorChanged()
    }

    this.getVendorDropDownList().then(r => {
      this.vendorsList = r
    })

    this.getDestinationsDropdownlist().then((r) => {
      this.destinationsDropDownList = r
      this.amReady = true
    })
  },
  methods: {
    makeSearch () {
      this.navigateToPage(1)
    },
    resetSearchFields () {
      this.fields['destination_id'].field.field_value = ''
      this.fields['destination_id'].field.updateValue()
      this.fields['destination_id'].field.validateMessage = ''

      this.fields['dialcode'].field.field_value = ''
      this.fields['dialcode'].field.updateValue()
      this.fields['dialcode'].field.validateMessage = ''

      this.dataModel.destination_id = ''
      this.dataModel.dialcode = ''
      this.vendorChanged()
    },
    destinationChanged() {

    },
    vendorChanged() {
      this.vendorIsSelected = true
      this.navigateToPage(1)
    },
    ...mapActions('voip-vendor-api', {
      getVendorDropDownList: 'getDropDownList',
      getVendorRate: 'getVendorRate'
    }),
    ...mapActions('voip-destination-api', {
      getDestinationsDropdownlist: 'getDropDownList'
    }),
    ...mapActions('voip-dialplan-state', ['addEntity']),
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      this.getVendorRate({
        id: this.dataModel.vendor_id,
        page,
        destinationId: this.dataModel.destination_id,
        dialcode: this.dataModel.dialcode
      }).then((r) => {
        this.rates = r.data.rows
        this.recordsCounter = r.data.count
      })
      this.currentPage = page;
      // $router.push({name: 'module->voip-vendor->rates-panel->tab', params: { tabName: 'viewRates', listPage: page}})
    },
    cancelEditable() {
      let context = this
      this.amReady = false
      this.editable = false
      Vue.nextTick(() => {
        context.amReady = true
      })
    },
    changeEditable() {
      this.editable = !this.editable
    },
    getEntityField() {
      return JSON.parse(this.openedEntity.fields);
    },
    removeAction(rateId) {
      let cxt = this
      this.requestOn = true
      this.$store.dispatch(this.module.info.name + '-api/removeRate', {id: rateId}).then(response => {
        this.rates.splice(scope.$index, 1)
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
          message: '',
          position: 'topRight',
          close: false,
          timeout: 1900,
          animateInside: true,
        });
      })
    },
    createModule() {
      this.validateFields().then(result => {
        if (!result) return

        this.requestOn = true
        let context = this;
        let data = {data: this.dataModel};
        if (this.editMode) {
          data.id = this.dataToBind.id;
        }

        let api = (this.editMode) ? 'update' : 'createManualRate';
        this.$store.dispatch(this.module.info.name + '-api/' + api, data).then(response => {
          this.amReady = false
          notify({
            type: 'success',
            title: this.$ml.get('successfully'),
            message: '',
            position: 'topRight',
            close: false,
            timeout: 1900,
            animateInside: true,
          });

          Vue.nextTick(() => {
            context.amReady = true
            context.requestOn = false
            if (context.editMode) {
              if (context.onEditCallback) {
                context.onEditCallback(response.data)
              }
            } else {
              if (context.onCreateCallback) {
                context.onCreateCallback(response.data)
              }
            }
          })
          // this.$router.push({ name: this.module.stateName + '-module-list', params: {}}).then( response => {})
        }).catch(error => {
          console.log('catch error', error)
          this.setfieldsErrorMessage({
            fieldsErrors: error.response.data
          });
        }).finally(() => {
          this.requestOn = false
        })

      })
    }
  }
}
</script>
